import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Alert } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import AssessmentCard from '../components/AssessmentCard';
import { useAssessmentService, AssignedAssessmentType } from '../services/assessmentService';

const AssessmentPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [assessments, setAssessments] = useState<AssignedAssessmentType[]>([]);
  const [loading, setLoading] = useState(true);
  const { fetchAssessments } = useAssessmentService();
  const assignmentError = location.state?.assignmentError as string | undefined;

  useEffect(() => {
    fetchAssessments()
      .then(data => setAssessments(data))
      .catch(err => {
        console.error('Failed to fetch assessments:', err);
        setAssessments([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4, minHeight: '100vh', overflowY: 'auto' }}>
      <PageHeader
        title="Select an assigned scenario..."
        subtitle="Evaluate your skills and track your progress"
        onBack={handleBack}
        showBackButton={true}
      />
      {assignmentError && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {assignmentError}
        </Alert>
      )}
      {loading ? (
        <div>Loading assessments...</div>
      ) : (
        <Box
      sx={{
        display: 'grid',
        gap: 3,
        width: '100%',
      }}
    >
      {assessments.map((assessment) => (
        <AssessmentCard
          key={assessment.id}
          assessmentId={assessment.id}
          title={assessment.title}
          description={assessment.description}
          duration={assessment.duration}
          meetingDetails={assessment.description}
          meetingSummary={assessment.meetingSummary}
          goals={assessment.goals}
          companyName={assessment.companyName}
          companyIndustry={assessment.companyIndustry}
          personaName={assessment.personaName}
          personaRole={assessment.personaRole}
          companyLocations={assessment.companyLocations}
          assignmentId={assessment.assignmentId}
          status={assessment.status}
          endDate={assessment.endDate}
          startDate={assessment.startDate}
        />
      ))}
    </Box>
      )}
      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          More Assessment Types Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We're continuously developing new assessment methods to help you improve your coaching skills.
        </Typography>
      </Box>
    </Container>
  );
};

export default AssessmentPage;